import routerOptions0 from "/home/forge/juleica.de/releases/20251006133937/client-frontend/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}